import { FC, ReactNode, useEffect } from 'react';

import { isInMobileApp } from '@/shared/utils/isInMobileApp';

import { LocalAssets } from '../api/assets';
import { isInBuilder } from '../utils/isInBuilder';
import { Footer, HeadTag, Header, HeaderSettings, JsTag } from './assets';

interface Props extends HeaderSettings {
  assetsData?: LocalAssets;
  children: ReactNode;
}

export const Layout: FC<Props> = ({
  assetsData,
  theme,
  partnershipLogo,
  stickyHeader,
  children,
}) => {
  const inApp = isInMobileApp();
  const insideBuilder = isInBuilder();

  useEffect(() => {
    if (inApp) {
      document.body.classList.remove('u-header-move-content-down');
      document.body.classList.remove('cookie-bar-is-visible');
    }
  }, [inApp]);

  useEffect(() => {
    if (!insideBuilder) return;

    // Delay removing cookie bar because the header is loading it
    // after the page is loaded
    setTimeout(() => {
      document.body.classList.remove('cookie-bar-is-visible');
      document.querySelector('.cw-cookies-bar')?.remove();
    }, 1000);
  }, [insideBuilder]);

  if (!assetsData) return <div>{children}</div>;

  return (
    <div className="u-typography-body">
      <HeadTag assetsData={assetsData} />
      {inApp ? null : (
        <Header
          assetsData={assetsData}
          theme={theme}
          partnershipLogo={partnershipLogo}
          stickyHeader={stickyHeader}
        />
      )}
      {children}
      {inApp ? null : <Footer assetsData={assetsData} />}
      <JsTag assetsData={assetsData} />
    </div>
  );
};
